import { lastValueFrom } from "rxjs";

import I18nLoaderInterface from "../../I18nLoaderInterface";
import { TranslationsApiServiceInterface } from "./TranslationsApiServiceInterface";

export class I18nApiLoader implements I18nLoaderInterface {
    constructor(
        private readonly namespace: string,
        private readonly locale: string,
        private readonly translationsApiService: TranslationsApiServiceInterface
    ) {}

    async load() {
        return lastValueFrom(
            this.translationsApiService.getTranslations(
                this.namespace,
                this.locale
            )
        );
    }
}
